/**
 * Reads `#best-companies-dimension-initial` JSON for dimension pages (hydration-safe snapshot).
 */

import type { Data } from './+data.server';

export const BEST_COMPANIES_DIMENSION_SCRIPT_ID = 'best-companies-dimension-initial';

export function getBestCompaniesDimensionDataFromScript(): Data | undefined {
  if (typeof document === 'undefined') return undefined;
  const el = document.getElementById(BEST_COMPANIES_DIMENSION_SCRIPT_ID);
  if (!el || el.tagName !== 'SCRIPT') return undefined;
  try {
    const raw = (el as HTMLScriptElement).textContent?.trim() ?? '';
    if (!raw) return undefined;
    const parsed = JSON.parse(raw) as Partial<Data>;
    if (!parsed || typeof parsed !== 'object' || parsed.config == null || typeof parsed.dimensionSlug !== 'string') {
      return undefined;
    }
    return parsed as Data;
  } catch {
    return undefined;
  }
}
